var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSconnService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.881 10.832H7.21076C6.50189 10.832 5.92725 11.4067 5.92725 12.1155V27.8844C5.92725 28.5933 6.50189 29.1679 7.21076 29.1679H32.881C33.5898 29.1679 34.1645 28.5933 34.1645 27.8844V12.1155C34.1645 11.4067 33.5898 10.832 32.881 10.832Z",
    fill: "url(#paint0_linear_1173_140982)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5652 18.2122L19.6242 17.6401C17.6769 17.3303 16.4246 16.9709 15.8671 16.5602C15.3097 16.1513 15.031 15.5865 15.031 14.8677C15.031 14.0628 15.3978 13.4082 16.1312 12.9003C16.8646 12.3924 17.8108 12.1394 18.9677 12.1394C21.1681 12.1394 22.9045 13.0488 24.1733 14.8696V15.8359C24.1733 16.0504 24.3475 16.2246 24.562 16.2246H27.5948C27.8093 16.2246 27.9835 16.0504 27.9835 15.8359V9.22397C27.9835 9.00944 27.8093 8.83525 27.5948 8.83525H24.562C24.3475 8.83525 24.1733 9.00944 24.1733 9.22397V9.78871C22.7193 8.95626 20.9279 8.54004 18.7972 8.54004C17.5265 8.54004 16.2925 8.78757 15.0934 9.28081C13.8942 9.77404 12.9096 10.5111 12.1413 11.4921C11.3712 12.4731 10.988 13.6539 10.988 15.0364C10.988 16.7435 11.5105 18.148 12.5539 19.2482C13.5972 20.3483 15.2419 21.124 17.4844 21.5768L19.7489 22.0646C21.709 22.446 23.0145 22.8164 23.6636 23.1757C24.3127 23.5351 24.6372 24.076 24.6372 24.7948C24.6372 25.7831 24.2283 26.5275 23.4105 27.0281C22.5927 27.5287 21.4706 27.7799 20.0459 27.7799C18.7477 27.7799 17.6091 27.4553 16.6281 26.8062C15.6471 26.1571 15.0512 25.2972 14.8403 24.2245V23.8505C14.8403 23.636 14.6662 23.4618 14.4516 23.4618H11.3345C11.12 23.4618 10.9458 23.636 10.9458 23.8505V30.6934C10.9458 30.908 11.12 31.0822 11.3345 31.0822H14.4516C14.6662 31.0822 14.8403 30.908 14.8403 30.6934V29.8757C15.5169 30.3267 16.3604 30.7044 17.3689 31.007C18.3773 31.3095 19.4041 31.4617 20.4475 31.4617C23.0713 31.4617 25.1781 30.842 26.7642 29.5988C28.352 28.3575 29.146 26.7146 29.146 24.6683C29.146 21.1698 26.9512 19.0172 22.5634 18.214L22.5652 18.2122Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1173_140982",
    x1: 5.92725,
    y1: 20,
    x2: 34.1645,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FFEE00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSconnService);
export default __webpack_public_path__ + "static/media/SconnService.c396824ac0ee2e61f31ad6d5a6979b6b.svg";
export { ForwardRef as ReactComponent };